/** Applies equipped cosmetics (visual only). Theme ids map to CSS variable sets in styles.css. */
export function applyCosmetics(equipped: Record<string, string> | null | undefined): void {
  const theme = equipped?.theme ?? 'theme_default';
  document.documentElement.dataset.cosmeticTheme = theme;
  try {
    localStorage.setItem('pa.cosmeticTheme', theme);
  } catch {
    /* ignore */
  }
}

export function restoreCosmetics(): void {
  try {
    const theme = localStorage.getItem('pa.cosmeticTheme');
    if (theme) document.documentElement.dataset.cosmeticTheme = theme;
  } catch {
    /* ignore */
  }
}
